import React, { useEffect, useRef } from 'react';
import { Formik } from 'formik';
import { Route, Switch } from 'react-router-dom';
import * as yup from 'yup';

import { MainScreen } from './Main';
import { useGetUserInfo } from '../../api/api';

const salesforceValidationScheme = yup.object().shape({
  firstName: yup.string().required('First name is required.'),
  lastName: yup.string().required('Last name is required.'),
  phone: yup.string().required('Phone is required.'),
  email: yup
    .string()
    .email('Email must be a valid email.')
    .required('Email is required.'),
});

const salesforceInitialValues = {
  firstName: '',
  lastName: '',
  email: '',
  phone: '',
  marketing:{
    phone: true,
    sms: true,
    email: true
  }
};
export const FormikWrapper = () => {
  const formikRef = useRef();
  return (
    <Formik
      initialValues={salesforceInitialValues}
      validationSchema={salesforceValidationScheme}
      onSubmit={() => {}}
    >
      {(formik) => {
        formikRef.current = formik;
        return (
          <MainScreen />
        )}}
    </Formik>
  );
};
